import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/services';

@Injectable({
  providedIn: 'root',
})
export class AppGuard implements CanActivate {
  private user: any;
  constructor(private authService: AuthService, private router: Router) {
    this.user = this.authService.userValue;
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const key = route && route.data && route.data.key;
    this.user = this.authService.userValue;

    if(this.user.isOTP){
      return this.router.createUrlTree(['/app/reset']);
    }
    if (
      [
        'dashboardAccess',
        'settingAccess',
        'approvalAccess',
        'campusAccess',
        'expenseAccess',
        'learnDevelopmentAccess'
      ].includes(key)
    ) {
      const permissionGranted =
        this.authService.userValue &&
        this.user?.roleClass?.permissionRef?.[key] !== 'NA';
      if (permissionGranted) return permissionGranted;
    } else {
      if (
        this.authService.userValue &&
        this.user?.roleClass?.permissionRef?.[key]?.includes('R')
      ) {
        return true;
      }
    }
    this.authService.logout();
    return false;
  }
}
